// extracted by mini-css-extract-plugin
export default {"circle":"AnimatedCheckmark_circle__tboNb"};